<template>
  <!-- one tab only (Settings): no tab bar (2026-10-18) -->
  <nav v-if="tabs.length > 1" class="tab-nav">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      :class="{active: modelValue === tab.id}"
      @click="$emit('update:modelValue', tab.id)"
    >{{ tab.label }}</button>
  </nav>
</template>

<script setup>
import {computed} from "vue";
import {getVisibleTabs} from "@/composables/useProfileTabs";

const props = defineProps(["modelValue", "isEditorOrAdmin", "hasEvents"]);
defineEmits(["update:modelValue"]);
// Events also while it's open (a tester's &step=2, an account without events)
const tabs = computed(() => {
  return getVisibleTabs(props.isEditorOrAdmin, props.hasEvents || props.modelValue === "events");
});
</script>

<style scoped>
.tab-nav {
  display: flex;
  gap: 10px;
  align-items: center;
}
button {
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 13px;
  padding: 2px 0;
  color: rgba(0, 0, 0, 0.35);
  font-family: inherit;
  font-weight: 700;
}
button:focus {
  outline: none;
}
button.active {
  color: var(--brand-dark-color); /* as #register's current breadcrumb (2026-10-14) */
}
button:hover:not(.active) {
  color: rgba(0, 0, 0, 0.7);
}
</style>
